import React from 'react';
import siteText from '../assets/siteText.json';
import './Footer.css';

const Footer = () => {
  const { legal } = siteText;

  return (
    <footer className="footer-container">
      <div className="footer-links">
        <a href={legal.cookiePolicyUrl} target="_blank" rel="noopener noreferrer">Cookie Policy</a>
        <a href={legal.privacyPolicyUrl} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
        <a href={legal.termsAndConditionsUrl} target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
      </div>
      <div className="footer-text">
        © {new Date().getFullYear()} Fig Tree Cottage. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
